export default "/_next/static/chunks/fonts/Cabin-Medium-latin-589fb9f8593a500f15020388137be331.woff2";